// Job Categories Constants for Frontend
const CATEGORIES = [
  // Primary 8 Categories (shown by default on homepage)
  'IT & Software Development',
  'Digital Marketing & Branding',
  'Creative & Design',
  'Media & Production',
  'Sales & Business Development',
  'Human Resources',
  'Education & Training',
  'E-Commerce',
  
  // Additional Categories
  'Administration & Operations',
  'Internship Opportunities',
  'UI/UX Design',
  'Data & Analytics',
  'Customer Support',
  'Banking & Finance',
  'Cloud & DevOps',
  'Healthcare',
  'Legal',
  'Freelance Opportunities',
  'Work From Home',
  'Other'
];

// Categories to display on homepage (first 8)
const PRIMARY_CATEGORIES = CATEGORIES.slice(0, 8);

// Category icons and metadata
const CATEGORY_METADATA = {
  'IT & Software Development': {
    icon: '💻',
    color: 'from-blue-50 to-blue-100',
    description: 'Web Developer, Mobile App Developer, Full Stack Developer, Java Developer, .NET Developer, Python Developer, AI/ML Engineer, Software Tester'
  },
  'Digital Marketing & Branding': {
    icon: '📱',
    color: 'from-purple-50 to-purple-100',
    description: 'SEO Executive, Digital Marketing Executive, Social Media Manager, Content Writer, Google Ads Specialist'
  },
  'Creative & Design': {
    icon: '🎨',
    color: 'from-pink-50 to-pink-100',
    description: 'Graphic Designer, Motion Graphic Designer, Video Editor, Animator (2D/3D), Creative Designer'
  },
  'Media & Production': {
    icon: '🎥',
    color: 'from-red-50 to-red-100',
    description: 'News Anchor, Reporter, Cameraman, Video Editor, Script Writer, Voice Over Artist'
  },
  'Sales & Business Development': {
    icon: '💼',
    color: 'from-green-50 to-green-100',
    description: 'Sales Executive, Business Development Executive (BDE), Business Development Manager, Telecaller'
  },
  'Human Resources': {
    icon: '👥',
    color: 'from-violet-50 to-violet-100',
    description: 'HR Executive, Talent Acquisition Specialist, Recruitment Executive, HR Intern'
  },
  'Education & Training': {
    icon: '📚',
    color: 'from-yellow-50 to-yellow-100',
    description: 'AI Trainer, Python Trainer, Java Trainer, .NET Trainer, Data Science Trainer'
  },
  'E-Commerce': {
    icon: '🛒',
    color: 'from-orange-50 to-orange-100',
    description: 'Amazon Executive, Flipkart Executive, Meesho Executive, Marketplace Manager'
  },
  'Administration & Operations': {
    icon: '⚙️',
    color: 'from-indigo-50 to-indigo-100',
    description: 'Office Administrator, Front Desk Executive, Operations Executive, Project Coordinator'
  },
  'Internship Opportunities': {
    icon: '🎓',
    color: 'from-cyan-50 to-cyan-100',
    description: 'Software Development Intern, Digital Marketing Intern, Graphic Design Intern'
  },
  'UI/UX Design': {
    icon: '🎯',
    color: 'from-teal-50 to-teal-100',
    description: 'UI/UX Designer, Product Designer, UX Researcher'
  },
  'Data & Analytics': {
    icon: '📊',
    color: 'from-green-50 to-green-100',
    description: 'Data Analyst, Business Analyst, Data Scientist'
  },
  'Customer Support': {
    icon: '🎧',
    color: 'from-gray-50 to-gray-100',
    description: 'Customer Support Executive, Support Manager, Technical Support'
  },
  'Banking & Finance': {
    icon: '💰',
    color: 'from-yellow-50 to-yellow-100',
    description: 'Finance Executive, Banking Officer, Accounts Manager'
  },
  'Cloud & DevOps': {
    icon: '☁️',
    color: 'from-sky-50 to-sky-100',
    description: 'DevOps Engineer, Cloud Architect, Cloud Engineer'
  },
  'Healthcare': {
    icon: '⚕️',
    color: 'from-rose-50 to-rose-100',
    description: 'Healthcare Professional, Medical Consultant'
  },
  'Legal': {
    icon: '⚖️',
    color: 'from-slate-50 to-slate-100',
    description: 'Legal Consultant, Lawyer, Paralegal'
  },
  'Freelance Opportunities': {
    icon: '🚀',
    color: 'from-fuchsia-50 to-fuchsia-100',
    description: 'Freelance Projects, Contract Work, Gig Work'
  },
  'Work From Home': {
    icon: '🏠',
    color: 'from-lime-50 to-lime-100',
    description: 'Remote Positions, Work From Home Jobs'
  },
  'Other': {
    icon: '📌',
    color: 'from-gray-50 to-gray-100',
    description: 'Other job categories'
  }
};

export { CATEGORIES, PRIMARY_CATEGORIES, CATEGORY_METADATA };
